// extracted by mini-css-extract-plugin
export default {"Description":"UPkrrwhg9w3UP9nkqorD","h2":"yZCU2vl4zZqGlu3iYg3H","content":"YMNZwgQ5MIou2EgCOAjO"};